// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../node_modules/@zxcabs/rtl-css-loader/index.js?dirTagName=body&diff=true!../../../node_modules/sass-loader/dist/cjs.js??ref--3-2!./style.scss");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../../node_modules/vue-style-loader/lib/addStylesClient.js").default
var update = add("ed39a4f0", content, true, {});